module.exports = __webpack_public_path__ + "img/loading.4278ed08.png";